import Requester from "../blueprint/svc";
import { handleSnackBar, handleTopRightInfo } from "../global/actions";
const fetch = new Requester();


export const searchForBackups = (data, limit, pageNumber) => async (dispatch) => {
    try {
        // console.log({ data})
        // console.log({limit})
        // console.log({pageNumber})

        let response = await fetch.post(fetch.route.searchBackup, { ...data, limit, pageNumber });
        
        if (response.status === false) {
            dispatch(handleSnackBar({ open: true, message: "Failed to fetch the backups.", severity: "error" }));
            return { status: response.status }
        }

        return { status: response.status, data: response.backups, recordCount: response.totalCount };

    }
    catch (error) {
        dispatch(handleSnackBar({ open: true, message: 'No data found.', severity: "error" }));
        return { status: false, error: error };
    }


}


export const deleteMultipleBackup = (backUps) => async (dispatch) => {
    try {
        console.log('backups------>', backUps)
        let response = await fetch.post(fetch.route.deleteMultiBackup, {backUps});
        if (response.status === false) {
            dispatch(handleSnackBar({ open: true, message: "Failed to delete the backups.", severity: "error" }));
            return { status: response.status }
        }

        return { status: response.status, message: response.message };

    }
    catch (error) {
        dispatch(handleSnackBar({ open: true, message: 'No data found.', severity: "error" }));
        return { status: false, message: error };
    }
}